import { render } from "./ModalOrder.vue?vue&type=template&id=40675f84&scoped=true"
import script from "./ModalOrder.vue?vue&type=script&lang=js"
export * from "./ModalOrder.vue?vue&type=script&lang=js"

import "./ModalOrder.vue?vue&type=style&index=0&id=40675f84&lang=css&scoped=true"

import exportComponent from "/Users/lucas/Documents/repo/tiototo-users-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40675f84"]])

export default __exports__